import { ImportStatusResponse } from '@epi-models/pages/MassUpload';

export const selectImportStatus = (state): ImportStatusResponse =>
  state.beneficiariesImport.importStatus;
